import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";

import { Logo, HeaderNavigation, SocialNavigation } from "components";

class Header extends PureComponent {
  state = {
    isOpen: false
  };

  handleOpenCloseNavigation = () => {
    const { isOpen } = this.state;

    isOpen
      ? document.documentElement.classList.remove("is-locked")
      : document.documentElement.classList.add("is-locked");

    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  componentWillUpdate(nextProps) {
    const { pathname } = this.props.location;
    if (pathname !== nextProps.location.pathname) {
      document.documentElement.classList.remove("is-locked");

      this.setState({
        isOpen: false
      });
    }
  }

  render() {
    const { isOpen } = this.state;

    return (
      <header className="header">
        <div className="wrapper">
          <div className="header__branding">
            <Logo />
          </div>
          <div className={`header__nav ${isOpen ? "is-open" : ""}`}>
            <HeaderNavigation />
          </div>
          <div className="header__social">
            <SocialNavigation />
          </div>
          <div className="header__mobilenav">
            <button
              onClick={this.handleOpenCloseNavigation}
              className={`hamburger hamburger--white ${
                isOpen ? "is-open" : ""
              }`}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx